import React from 'react';

export const ChevronLeftIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="#292E2E" fillRule="evenodd"/>
  </svg>

);
